import { Chip, ChipProps, styled, Tooltip, useTheme } from '@mui/material';
import { TypeCompanyProfileType } from 'src/utils/constants/enum';
import { alpha } from '@mui/material/styles';

export interface ICompanyProfileTagProps extends ChipProps{
  colorType: 'transparent' | 'solid'
}

const StyledCompanyProfileTag = styled(Chip)<ICompanyProfileTagProps>(({ theme, colorType, sx }) => {
  const backgroundColor = (sx as any)?.backgroundColor;
  const color = (sx as any)?.color;

  return {
    width: 'fit-content',
    backgroundColor,
    color,
    '&:hover': {
      width: 'fit-content',
      backgroundColor,
      color
    }
  }
})

export const OfficialRecordTag = (props: ICompanyProfileTagProps) => {
  const theme = useTheme()
  const color = props.colorType === 'solid' ? 'white' : theme.palette.success.main
  const backgroundColor = props.colorType === 'solid' ? theme.palette.success.main : alpha(theme.palette.success.main, 0.1)
  return <Tooltip title="An official company record is a government-verified entry with details like registration number, name, incorporation date, address, and directors.">
    <StyledCompanyProfileTag
      label="Official Company Record"
      size="small"
      sx={{
        backgroundColor,
        color
      }}
      clickable={false}
      {...props}
    />
  </Tooltip>

}

export const NonOfficialRecordTag = (props: ICompanyProfileTagProps) => {
  const theme = useTheme()
  const color = props.colorType === 'solid' ? 'white' : theme.palette.error.main
  const backgroundColor = props.colorType === 'solid' ? theme.palette.error.main : alpha(theme.palette.error.main, 0.1)
  return <Tooltip title="A non-official record is a placeholder entry not yet matched to government or LEI data, often due to limited access, synchronization delays, or name discrepancies.">
    <StyledCompanyProfileTag
      label="Non-Official Record"
      size="small"
      sx={{
        backgroundColor,
        color
      }}
      clickable={false}
      {...props}
    />
  </Tooltip>
}

export const OfficialLEIRecordTag = (props: ICompanyProfileTagProps) => {
  const theme = useTheme()
  const color = props.colorType === 'solid' ? 'white' : theme.palette.warning.main
  const backgroundColor = props.colorType === 'solid' ? theme.palette.warning.main : alpha(theme.palette.warning.main, 0.1)
  return <Tooltip title="An LEI is a 20-character code identifying legal entities in financial transactions, promoting global transparency and trust.">
    <StyledCompanyProfileTag
      label="Official LEI Record"
      size="small"
      sx={{
        backgroundColor,
        color
      }}
      clickable={false}
      {...props}
    />
  </Tooltip>
}

interface ICompanyProfileTagsMapping extends Record<TypeCompanyProfileType, (props: ICompanyProfileTagProps) => JSX.Element>{
}

export const CompanyProfileTagsMapping: ICompanyProfileTagsMapping = {
  [TypeCompanyProfileType.OFFICIAL_COMPANY]: OfficialRecordTag,
  [TypeCompanyProfileType.NON_OFFICIAL]: NonOfficialRecordTag,
  [TypeCompanyProfileType.OFFICIAL_LEI]: OfficialLEIRecordTag,
}
